import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ShipmentStatusMappingAdapter } from '../adapters/shipmentStatusMappingAdapter';
import type { ShipmentStatusMappingFilters } from '../models/shipmentStatusMapping.types';

export const useShipmentStatusMappings = (filters: ShipmentStatusMappingFilters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ShipmentStatusMappingAdapter(httpClient);

  const queryKey = ['shipment-status-mappings', filters];

  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching, isPending } =
    useInfiniteQuery({
      queryKey,
      queryFn: ({ pageParam = 1 }) =>
        adapter.fetchShipmentStatusMappingsPaginated({ ...filters, page: pageParam, per_page: 25 }),
      getNextPageParam: (lastPage) => lastPage.nextPage,
      initialPageParam: 1,
      staleTime: 2 * 60 * 1000,
      gcTime: 5 * 60 * 1000,
    });

  const mappings = data?.pages.flatMap((page) => page.mappings) ?? [];
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    mappings,
    isLoading: isLoading || isPending,
    isFetching,
    isFetchingFilters: isFetching && !isFetchingNextPage,
    error,
    refetch,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    total: totalFromApi,
  };
};
